import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule, NavParams } from '@ionic/angular';

import { AddContactPersonPageRoutingModule } from './add-contact-person-routing.module';

import { AddContactPersonPage } from './add-contact-person.page';
import { ComponentsModule } from '../../../components/components.module'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ComponentsModule,
    IonicModule,
    AddContactPersonPageRoutingModule
  ],
  declarations: [AddContactPersonPage]
})
export class AddContactPersonPageModule {}
